import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardModule } from 'primeng/card';
import { TableModule } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';
import { DividerModule } from 'primeng/divider';

interface TableRow {
  country: string;
  city: string;
  sessions: number;
  activeUsers: number;
  newUsers: number;
}

@Component({
  selector: 'gig-ga-summary-table',
  standalone: true,
  imports: [CommonModule, CardModule, TableModule, TooltipModule,DividerModule],
  templateUrl: './ga-summary-table.component.html',
  styleUrls: ['./ga-summary-table.component.scss']
})
export class GaSummaryTableComponent {
  @Input() title: string;
  @Input() toolTipPath: string;
  @Input() showUpDwnImg: boolean = false;
  @Input() tableData: TableRow[] = [];
  @Input() totals: { totalSessions: number; totalActiveUsers: number; totalNewUsers: number };

  sortField: string = '';
  sortOrder: number = 1;

  onSort(event: any) {
    this.sortField = event.field;
    this.sortOrder = event.order;
  }
}
